import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import EnforcerDashboard from "@/pages/EnforcerDashboard";
import RemovalDashboard from "@/pages/RemovalDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ForgotPassword from "@/pages/ForgotPassword";

function RoleRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0B0F17]" />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "enforcer") return <EnforcerDashboard />;
  if (user.role === "runner") return <EnforcerDashboard runner />;
  if (user.role === "removal") return <RemovalDashboard />;
  return <div className="text-white p-8">Unknown role</div>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<RoleRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
